import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TaskService } from '../../services/task.service';
import { UserService } from '../../services/user.service';
import { UserHelperComponent } from '../user-helper/user-helper.component';
import { NotifyService } from '@farris/ui-notify';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'wf-task-transfer',
  templateUrl: '../user-helper/user-helper.component.html',
  styleUrls: ['./task-transfer.component.css']
})
export class TaskTransferComponent extends UserHelperComponent implements OnInit {

  @Input()
  public set transfer_context(context: { workItemId: string, comment?: string}) {
    this.transferContext = { ...context, assignee: '' };
    this.selectedUsers = [];
    this.showModal(!!this.transferContext.workItemId);
  }
  @Output()
  completed = new EventEmitter<boolean>();

  transferContext: {
    workItemId: string,
    assignee: string,
    comment?: string // TODO：移交备注
  };
  constructor(
    private taskSvc: TaskService,
    protected userSvc: UserService,
    protected notify: NotifyService,
    protected i18nService: I18nService
  ) {
    super(i18nService, userSvc);
    this.singleSelect = true;
    this.paginationOptions.id = 'WF-TaskTransfer-DataTable-Pagination';
  }

  ngOnInit() {
  }

  handleOk(): void {
    this.selectedUsers = this.userTable.selections;
    // 需要校验选中唯一用户
    if (!this.selectedUsers) {
      this.notify.info(this.i18nService.getValue('static.transfer.selectHandover'));
      return;
    }

    this.transferContext.assignee = this.selectedUsers['ID'];
    this.taskSvc.transfer(this.transferContext).subscribe(() => {
      this.notify.success(this.i18nService.getValue('static.transfer.successTransfer'));
      this.completed.emit(true);
      this.showModal(false);
    }, error => {
      if(error && error.error && error.error.Message) {
        this.notify.error(error.error.Message);
      }
    });
  }
}
